<template>
  <v-container v-if="snackbar">
    <v-snackbar
        v-model="snackbar"

        :bottom="snackbarOptions.y === 'bottom'"
        :left="snackbarOptions.x === 'left'"
        :multi-line="snackbarOptions.mode === 'multi-line'"
        :right="snackbarOptions.x === 'right'"
        :timeout="snackbarOptions.timeout"
        :top="snackbarOptions.y === 'top'"
        :vertical="snackbarOptions.mode === 'vertical'"
      >
        {{ snackbarOptions.text }}
        <v-btn
          color="green lighten-2"
          flat
          @click="snackbar = false"
        >
          Close
        </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import defaults from 'lodash/defaults'

export default {
  name: 'snackbar',
  data () {
    return {
      snackbar: false,
      snackbarOptions: {},
      snackbarDefaults: {
        color: 'success',
        y: 'top',
        x: null,
        mode: '',
        timeout: 6000,
        text: ''
      }
    }
  },
  created: function () {
    this.$store.watch(state => state.snackbarOptions, () => {
      const snackbarConfig = this.$store.state.snackbarOptions
      if (snackbarConfig) {
        this.snackbarOptions = defaults(
          snackbarConfig,
          this.snackbarDefaults
        )
      }
      this.snackbar = true
    })
  }
}
</script>
